import { ESuburbanWCType, getTermValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { SUBURBAN_WC_MAP_VALUE_TO_LABEL } from './constants';

const ID = 'suburbanWc' as const;

export const suburbanWcTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const suburbanWc = getTermValue('wc_site')(jsonQuery);

    if (suburbanWc === null || suburbanWc === undefined || suburbanWc === ESuburbanWCType.Any) {
      return null;
    }

    const label = `Санузел ${SUBURBAN_WC_MAP_VALUE_TO_LABEL[suburbanWc]}`;

    return [{ label, value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['wc_site'])(jsonQuery),
};
